"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFnAbstract = exports.encode = void 0;
var toStr_1 = __importDefault(require("licia/toStr"));
var trim_1 = __importDefault(require("licia/trim"));
var escape_1 = __importDefault(require("licia/escape"));
var encode = function (str) {
    return (0, escape_1.default)((0, toStr_1.default)(str))
        .replace(/\n/g, '↵')
        .replace(/\f|\r|\t/g, '');
};
exports.encode = encode;
function getFnAbstract(str) {
    if (str.length > 500)
        str = str.slice(0, 500) + '...';
    return 'ƒ ' + (0, trim_1.default)(extractFnHead(str).replace('function', ''));
}
exports.getFnAbstract = getFnAbstract;
var regFnHead = /function(.*?)\((.*?)\)/;
function extractFnHead(str) {
    var fnHead = str.match(regFnHead);
    if (fnHead)
        return fnHead[0];
    return str;
}
